import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { api } from '@/lib/api';
import AdminLogin from '@/admin/AdminLogin';
import AdminDashboard from '@/admin/AdminDashboard';

export default function AdminApp() {
  const [authed, setAuthed] = useState(!!localStorage.getItem('seicon_admin_token'));
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('seicon_admin_token');
    if (!token) { setAuthed(false); setChecking(false); return; }
    api.get('/admin/me').then(() => { setAuthed(true); setChecking(false); }).catch(() => { setAuthed(false); setChecking(false); });
  }, []);

  const onLoginSuccess = () => { setAuthed(true); navigate('/admin'); };
  const onLogout = () => {
    localStorage.removeItem('seicon_admin_token');
    setAuthed(false);
    navigate('/admin');
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-canvas">
        <div className="h-8 w-8 rounded-full border-2 border-brand-orange border-t-transparent animate-spin" />
      </div>
    );
  }

  if (!authed) return <AdminLogin onSuccess={onLoginSuccess} />;

  return <AdminDashboard onLogout={onLogout} />;
}
